export default "__VITE_ASSET__B3Zj1b4l__"